import React, {useState, useContext, useEffect} from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonButton } from '@ionic/react';

import { ViewUploadedTemplatesModal } from './Modal_ViewUploadedTemplates';
import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';
import { CapabilitiesModal } from './Modal_Capabilities';
import { BackUp_CustomerModal } from './Modal_Backup_Customer';
import { DeleteCustomerModal } from './Modal_Delete_Customer';


export function ManageCustomerModal(props) {

    let zasava_context = useContext(Auth_Zasava_Context);


    let [acctID, setAcctID ] = useState(zasava_context.acctID);
    let [schema, setSchemaName] = useState(zasava_context.schema);
    let [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    let [viewUploadedTemplatesModal, setUploadedTemplatesModal] = useState(false);
    let [viewCapabilitiesModal, setCapabilitiesModal] = useState(false);

    let [viewBackupMercantModal, setBackUpMerchantModal] = useState(false);
    let [viewDeleteMerchantModal, setDeleteMerchantModal] = useState(false);

    let [viewBackupUserModal, setBackUpUserModal] = useState(false);
    let [viewDeleteUserModal, setDeleteUserModal] = useState(false);

    let [customerID, setCustomerD] = useState(props.data.customerID);
    let [customerSchema, setCustomerSchema] = useState(props.data.customerSchema);


    //alert('In Manage Mercahnt Modal');
    //alert(props.data.customerID);
    //alert(customerID);
    //alert(customerSchema);


    function uploadedTemplatesHandler(event) {

        //setCustomerD(event[1]);
        setCustomerSchema(event[2]);
        setUploadedTemplatesModal(event[0]);

    }

    function capabilitiesHandler(event) {
        
        //setCustomerD(event[1]);
        setCapabilitiesModal(event[0]);

    }

    function backupMerchantHandler(event) {

        //setCustomerD(event[1]);
        setBackUpMerchantModal(event[0]);

    }

    function deleteMerchantHandler(event) {

        //setCustomerD(event[1]);
        setDeleteMerchantModal(event[0]);
    }
 
    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        //setViewMerchantList([]);
        props.closeModal(event);
    }

    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        //setViewInventoryAvailableRooms([]);
        props.closeModal(event);
    }

    return (

        <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal isOpen={ props.openModal }>
                <IonSlides>
                    <IonSlide>

                        <IonItem>
                            <IonButton class='gridResultColumnButton' onClick={() => uploadedTemplatesHandler([true, customerID, customerSchema])}> Upload Invoice Template </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonButton class='gridResultColumnButton' onClick={() => capabilitiesHandler([true, customerID])}> Capabilities </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonButton class='gridResultColumnButton' onClick={() => backupMerchantHandler([true, customerID])}> Back-up Customer </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonButton class='gridResultColumnButton' onClick={() => deleteMerchantHandler([true, customerID])}> Delete Customer </IonButton>                         
                        </IonItem>
                    </IonSlide>
                </IonSlides>
                <IonButton onClick={closeModalHandler}>Cancel </IonButton>

               {    props.data.customerID != null &&  <ViewUploadedTemplatesModal openModal={ viewUploadedTemplatesModal } closeModal={() => setUploadedTemplatesModal(false)} data={{
                        customerID: props.data.customerID, 
                        customerSchema: props.data.customerSchema,
                        }}></ViewUploadedTemplatesModal>    }

                
               {    props.data.customerID != null &&  <CapabilitiesModal openModal={ viewCapabilitiesModal } closeModal={() => setCapabilitiesModal(false)} data={{
                        customerID: props.data.customerID, 
                        customerSchema: props.data.customerSchema,
                        }}></CapabilitiesModal>    }


                    {    props.data.customerID != null &&  <BackUp_CustomerModal openModal={ viewBackupMercantModal } closeModal={() => setBackUpMerchantModal(false)} data={{
                        customerID: props.data.customerID, 
                        customerSchema: props.data.customerSchema,
                        }}></BackUp_CustomerModal>    }

                {    props.data.customerID != null &&  <DeleteCustomerModal openModal={ viewDeleteMerchantModal } closeModal={() => setDeleteMerchantModal(false)} data={{
                        customerID: props.data.customerID, 
                        customerSchema: props.data.customerSchema,
                        }}></DeleteCustomerModal>    }





            </IonModal>) : null}
        </React.Fragment>
    )
}